import { sortTerms } from '../term'

export const getSortedTermsByPageType = (
  data,
  pageType,
  key,
  additionalKey = null
) => {
  const baseKey = `centers_${pageType}`
  let items = data && data[baseKey] && data[baseKey][key]
  if (additionalKey) {
    const additionalItems =
      data && data[baseKey] && data[baseKey][additionalKey]
    items = items
      ? additionalItems
        ? items.concat(additionalItems)
        : items
      : additionalItems
  }
  return items ? items.sort(sortTerms) : []
}
